// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  url: 'https://saferoads.ph',
  production: false,

  luxandURL: 'https://api.luxand.cloud',

  cmsServiceURL: 'https://saferoadsph-reports-service-legacy.azurewebsites.net/api/v1',
  userServiceURL: 'https://saferoadsph-user-service-legacy.azurewebsites.net/api/v1',
  courseServiceURL:
    'https://saferoadsph-module-service-legacy.azurewebsites.net/api/v1',
  paymentServiceURL:
    'https://saferoadsph-payment-service-legacy.azurewebsites.net/api/v1',
  dsControlPanelURL:'https://ad.saferoads.ph/',

  azureFaceApiEndPoint: 'https://saferoadsph.cognitiveservices.azure.com/',

  paymongoURL: 'https://api.paymongo.com/v1/',

  paymayaURL: 'https://pg.maya.ph/checkout/v1/', 


};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
